import React, { ReactNode } from "react";

interface InputDivProps {
  text: string;
  children?: ReactNode;
  className?: string; // Allow custom class names to be passed
  backButton?: boolean;
  onClick?: () => void;
}

const InputDiv = (props: InputDivProps) => {
  return (
    <div
      className={`bg-bg-page-body mt-6 px-[12px] overflow-hidden h-full flex-grow rounded-t-2xl shadow-2xl ${props.className}`}
    >
      {/* <Switcher tabs={tabs} /> */}
      <div className="py-3 px-1 sticky top-0">
        <div className="flex items-center">
          {props.backButton && <span className="material-symbols-outlined cursor-pointer" onClick={props.onClick}>
            arrow_back_ios
          </span>}
          <p className="text-text-base text-center text-[14px] font-semibold">
            {props.text}
          </p>
        </div>
      </div>
      <div className="border-[0.5px] border-border-table"></div>
      <div className="overflow-y-scroll">
        {props.children}
      </div>
    </div >
  );
};

export default InputDiv;
